import React from 'react';
import { Typography, Row, Col, Button, Divider } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ArticleCard from './ArticleCard';
import { pressReleasesSorted } from '../content/press';
import './PressPage.css';

const { Title, Text, Paragraph } = Typography;

const PressPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="press-page">
      <nav className="press-navbar">
        <div className="nav-container">
          <div className="nav-left">
            <div
              className="nav-logo"
              role="button"
              tabIndex={0}
              onClick={() => navigate('/')}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  navigate('/');
                }
              }}
            >
              <img src="/sns-focus-logo.png" alt="SNS Intelligence" />
            </div>
            <div className="nav-links">
              <a href="/platform">Platform</a>
              <a href="/markets">Markets</a>
              <a href="/pulse">Pulse</a>
              <a href="/press">Press</a>
            </div>
          </div>
          <div className="nav-actions">
            <Button type="primary" onClick={() => navigate('/login')}>Open Portal</Button>
          </div>
        </div>
      </nav>

      <div className="back-to-home-section">
        <Button
          type="default"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/')}
          className="back-to-home-button"
        >
          Back to Home
        </Button>
      </div>

      <div className="press-container">
        <Row justify="center">
          <Col xs={24} md={20} lg={18}>
            <header className="press-header">
              <Title level={1} className="press-title">
                Press
              </Title>
              <Text className="press-subtitle">
                Official Announcements &amp; Product Updates
              </Text>
            </header>

            <section className="press-intro" aria-label="About Press">
              <Paragraph className="press-intro-paragraph">
                Official announcements and platform launches from SNS Intelligence. Each release covers a
                specific product expansion, methodology update, or strategic milestone, with a media contact for
                follow-up.
              </Paragraph>
            </section>

            <section aria-label="Press releases">
              <h2 className="press-section-heading">Releases</h2>
              <div className="article-card-grid">
                {pressReleasesSorted.map((release) => (
                  <ArticleCard
                    key={release.slug}
                    href={`/press/${release.slug}`}
                    date={release.displayDate}
                    title={release.title}
                    excerpt={release.excerpt}
                    badge="Press release"
                  />
                ))}
              </div>
            </section>
          </Col>
        </Row>
      </div>

      <footer className="press-footer">
        <div className="section-container">
          <div className="footer-content">
            <div className="footer-logo-section">
              <div className="footer-logo">
                <img src="/sns-focus-logo.png" alt="SNS Intelligence" />
              </div>
            </div>
            <div className="footer-links-section">
              <div className="footer-column">
                <Title level={5}>Product</Title>
                <div className="footer-links">
                  <a href="/platform">Platform</a>
                  <a href="/data-coverage">Data Coverage</a>
                  <a href="/markets">Markets</a>
                  <a href="/pulse">Pulse</a>
                </div>
              </div>
              <div className="footer-column">
                <Title level={5}>Company</Title>
                <div className="footer-links">
                  <a href="/about">About</a>
                  <a href="/contact">Contact</a>
                  <a href="/press">Press</a>
                </div>
              </div>
            </div>
          </div>
          <Divider />
          <div className="footer-bottom">
            <Text>&copy; 2026 SNS Intelligence. All rights reserved.</Text>
            <div className="footer-legal">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PressPage;
